import React from "react";
import { logoSection } from "../content/landingContent";
import { CtaButton } from "./CtaButton";
import { Reveal } from "./Reveal";
import { useResourceImage } from "../lib/useResourceImage";
import { useContentField, useLinks } from "../lib/useContent";
import { trackLead, trackViewContent } from "../lib/metaPixel";
import logoFull from "../assets/brand/logo-full.webp";
import { ArrowRight, Search } from "lucide-react";

export const LogoSection: React.FC = () => {
  const { src: logoFullSrc } = useResourceImage("logoSection.background", logoFull);
  const links = useLinks();
  const title = useContentField("logoSection.title", logoSection.title);
  const subtitle = useContentField("logoSection.subtitle", logoSection.subtitle);
  const ctaPrimary = useContentField("logoSection.ctaPrimary", logoSection.ctaPrimary);
  const ctaSecondary = useContentField("logoSection.ctaSecondary", logoSection.ctaSecondary);
  return (
    <section
      data-testid="logo-showcase-section"
      className="relative py-28 sm:py-32 lg:py-40 overflow-hidden"
    >
      <img
        src={logoFullSrc}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-black/70" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/60" />

      <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
            {title}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-white/80 max-w-xl mx-auto leading-relaxed">
            {subtitle}
          </p>
          <div className="mt-9 flex flex-col sm:flex-row justify-center gap-3.5">
            <CtaButton
              href={links.appUrl}
              onClick={() => trackLead("logo_section_download")}
              testId="logo-section-download-button"
              icon={<ArrowRight className="h-4 w-4" />}
            >
              {ctaPrimary}
            </CtaButton>
            <CtaButton
              href={links.exploreUrl}
              onClick={() => trackViewContent("logo_section_explore")}
              variant="ghost-dark"
              testId="logo-section-explore-button"
              icon={<Search className="h-4 w-4" />}
            >
              {ctaSecondary}
            </CtaButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
